/**
 * Shared space backdrop helpers (exact Figma geometry — nothing code-drawn).
 *
 * The game/intro scenes use the designer's per-round background PLATES
 * (bg-round-N: black + starfields + that round's scenery, baked) with the
 * launchpad platform sprite drawn on top. The start screen has its own scene
 * (starfields + sun + earth) and uses addStarfields directly.
 */

export const SPACE_BG = '#191919'; // node 536:750 fill (shows during fades)

const STARFIELD_A = { x: 604, y: 229 }; // Group 76073  1223x577 @ rel(-8,-60)
const STARFIELD_B = { x: 633, y: 477 }; // Group 76218  1337x980 @ rel(-36,-13)
const LAUNCHPAD = { x: 640, y: 548 }; // 536:1020  1716x957 @ rel(-218,69)

/** Start-screen starfields (the start scene has no bg plate). */
export function addStarfields(scene) {
  scene.add.image(STARFIELD_A.x, STARFIELD_A.y, 'starfield-a').setDepth(0);
  scene.add.image(STARFIELD_B.x, STARFIELD_B.y, 'starfield-b').setDepth(0);
}

/** The launchpad platform sprite, drawn on top of a round background plate. */
export function addLaunchpad(scene) {
  return scene.add.image(LAUNCHPAD.x, LAUNCHPAD.y, 'bg-launchpad').setDepth(1);
}

/**
 * Background-plate texture key for a round (0 = tutorial, 1..9 scored). There
 * are 6 distinct plates (rounds 1 & 4 are plain dark space; 2/3/5/6 have
 * scenery), cycled across the rounds.
 */
export function roundBgKey(roundIndex) {
  return `bg-round-${(roundIndex % 6) + 1}`;
}
